import React, { Component } from 'react'

class Notifications extends Component {
  constructor(props, context) {
    super(props, context)
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClick, false)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick, false)
  }

  handleClick = event => {
    if (!event.target.classList.contains('header__notify')) {
      this.props.toggleNotificationBox()
    }
  }

  renderNotificationList = notifications => {
    return notifications.map((item, index) => {
      return (
        <li
          key={index}
          className="cw_notification pointer header__notify"
          onClick={() => this.props.toggleNotificationBox()}
        >
          <div
            className="cw_notification-header header__notify"
            style={{ color: '#0070ba' }}
          >
            {item.name}
          </div>
          <div className="cw_notification-description header__notify">
            {item.date}
          </div>
        </li>
      )
    })
  }

  renderNoNotificationMsg = () => {
    return <li>No notifications</li>
  }

  render() {
    const { notifications } = this.props
    return (
      <div
        id="notifications-popover"
        className="cw_popover-container cw_notifications-container
          cw_popoverPrepToOpen cw_popoverIsOpening cw_popoverIsOpen
          header__notify"
        style={{ left: '-134px' }}
        aria-label="Popover Dialog"
      >
        <div
          className={`cw_popover-body header__popover-body header__notify ${
            notifications.length > 0 ? '' : 'flexCenter'
          }`}
        >
          <ul
            className="cw_panel cw_panel_notifications cw_panel_selected header__notify"
            id="cw_panel-notifications"
          >
            {notifications.length > 0
              ? this.renderNotificationList(notifications)
              : this.renderNoNotificationMsg()}
          </ul>
        </div>
      </div>
    )
  }
}

export default Notifications
